import React, { useState, useRef, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";
import { Calendar } from "primereact/calendar";
import { Toast } from "primereact/toast";
import { ProgressSpinner } from "primereact/progressspinner";
import axios from "axios";
import { SERVICE_LOCATION, FITTER_SIGNIN_REPORT } from "../constants/endpoints";

import "./../assets/styles/table.css";
import "./../assets/styles/fitter.css";
import "./../assets/styles/reports.css";

const FitterSignInReport = (props) => {
    const { data } = props;

    const toast = useRef(null);

    const [fitterSignInReportData, setFitterSignInReportData] = useState(null);
    const [filteredReportData, setFilteredReportData] = useState(null);
    const [selectedDate, setSelectedDate] = useState(null);
    const [loading, setLoading] = useState(false);

    const [filters, setFilters] = useState(null);
    const [globalFilterValue, setGlobalFilterValue] = useState("");

    useEffect(() => {
        const currentDate = new Date();
        setSelectedDate(currentDate);
        getFitterSignInData(currentDate);
        initFilters();
    }, []);

    const getFormattedDate = (dateToFormat) => {
        const year = dateToFormat.getFullYear();
        const month = String(dateToFormat.getMonth() + 1).padStart(2, "0");
        const day = String(dateToFormat.getDate()).padStart(2, "0");
        const formatedDate = `${year}-${month}-${day}`;
        return formatedDate;
    }

    const getFitterSignInData = (date) => {
        setLoading(true);
        const formattedDate = getFormattedDate(date);
        const requestedData = {
            SelectedDate: formattedDate
        }

        const endPoint = SERVICE_LOCATION + FITTER_SIGNIN_REPORT;
        axios.post(endPoint, requestedData, {
            headers: {
                Authorization: `Bearer ${data.data.token}`,
            },
        })
            .then((response) => {
                setLoading(false);
                if (response.data.isSuccess) {
                    const fitterSignInData = response.data.data.fitterSignInData;
                    setFitterSignInReportData(fitterSignInData);
                    setFilteredReportData(fitterSignInData);
                }
                else if (!response.data.isSuccess) {
                    setFitterSignInReportData(null);
                    setFilteredReportData(null);
                    toast.current.show({ severity: "error", summary: "Error", detail: response.data.errorMessage, life: 3000 });
                }
            })
            .catch((error) => {
                setFitterSignInReportData(null);
                setFilteredReportData(null);
                toast.current.show({ severity: "error", summary: "Error", detail: error, life: 3000 });
            })
    };

    const handleSelectedDateChange = (e) => {
        const dateSelected = e.value;
        setSelectedDate(dateSelected);
        getFitterSignInData(dateSelected);
    }

    const getFilteredReportData = (filteredData) => {
        setFilteredReportData(filteredData);
    }

    //export functionality
    const saveAsExcelFile = (buffer, fileName) => {
        import("file-saver").then((module) => {
            if (module && module.default) {
                let EXCEL_TYPE = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                let EXCEL_EXTENSION = ".xlsx";
                const data = new Blob([buffer], {
                    type: EXCEL_TYPE
                });

                module.default.saveAs(data, fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION);
            }
        });
    };

    const exportExcel = () => {
        import("xlsx").then((xlsx) => {
            const worksheet = xlsx.utils.json_to_sheet(filteredReportData);
            const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
            const excelBuffer = xlsx.write(workbook, {
                bookType: "xlsx",
                type: "array"
            });

            saveAsExcelFile(excelBuffer, "FitterSignInReport");
        });
    };
    //end export functionality

    // Search functionality
    const clearFilter = () => {
        initFilters();
    };

    const initFilters = () => {
        setFilters({
            global: { value: null, matchMode: FilterMatchMode.CONTAINS },
            clientAccount: { value: null, matchMode: FilterMatchMode.CONTAINS },
            clientName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            site: { value: null, matchMode: FilterMatchMode.CONTAINS },
            systemId: { value: null, matchMode: FilterMatchMode.CONTAINS },
            fitterId: { value: null, matchMode: FilterMatchMode.CONTAINS },
            fitterName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            depotCode: { value: null, matchMode: FilterMatchMode.CONTAINS },
            depotName: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureId: { value: null, matchMode: FilterMatchMode.CONTAINS },
            worksheetNo: { value: null, matchMode: FilterMatchMode.CONTAINS },
            measureType: { value: null, matchMode: FilterMatchMode.CONTAINS },
            plannedDate: { value: null, matchMode: FilterMatchMode.CONTAINS },
            submissionType: { value: null, matchMode: FilterMatchMode.CONTAINS },
            submissionStatus: { value: null, matchMode: FilterMatchMode.CONTAINS },
            signIn: { value: null, matchMode: FilterMatchMode.CONTAINS },
            signOut: { value: null, matchMode: FilterMatchMode.CONTAINS },
            hoursWorked: { value: null, matchMode: FilterMatchMode.CONTAINS }
        });
        setGlobalFilterValue("");
    }

    const renderHeader = () => {
        return (
            <div className="row">
                <div className="col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                    <div className="flex align-items-center justify-content-end gap-2">
                        <Button className="mar-r-10" type="button" icon="pi pi-file-excel" severity="success" onClick={exportExcel} rounded tooltip="Export Report" />
                    </div>
                </div>
                <div className="col-12 col-sm-9 col-md-9 col-lg-9 col-xl-9">
                    <div className="flex justify-content-end txt-right">
                        <Button className="mar-r-10" type="button" icon="pi pi-filter-slash" label="Clear" outlined onClick={clearFilter} tooltip="clear filters" tooltipOptions={{ position: "bottom" }} />
                        <span className="p-input-icon-left">
                            <i className="pi pi-search" />
                            <InputText value={globalFilterValue} onChange={onGlobalFilterChange} placeholder="Keyword Search" />
                        </span>
                    </div>
                </div>

            </div>
        );
    };

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };

        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const header = renderHeader();
    // Search functionality Ends here

    return (
        <div className={`app ${loading ? "disabled" : ""}`}>
            {
                loading &&
                <div className="spinner-overlay">
                    <ProgressSpinner style={{ width: "50px", height: "50px" }} strokeWidth="8" fill="var(--surface-ground)" animationDuration=".5s" />
                </div>
            }

            <Toast ref={toast} />

            <div className="worksheets-section padl-20">
                <h4>Fitter SignIn Report</h4>
                <div className="row pad-tb-10">
                    <div className="col-3">
                        <label htmlFor="select-date">Select Date</label>
                        <Calendar id="select-date" name="select-date" value={selectedDate} onChange={handleSelectedDateChange} showIcon dateFormat="dd/mm/yy" />
                    </div>
                </div>

                <div className="row">
                    <div className="col-12">
                        <DataTable className="font-12" value={fitterSignInReportData} dataKey="measureId" paginator rows={10}
                            rowsPerPageOptions={[10, 25, 50]} filters={filters} header={header} filterDisplay="row" onValueChange={getFilteredReportData}
                            globalFilterFields={["clientAccount", "clientName", "site", "fitterId", "fitterName", "depotCode", "depotName", "measureId", "worksheetNo",
                                "measureType", "plannedDate", "submissionType", "signIn", "signOut", "hoursWorked"]}
                            scrollable tableStyle={{ minWidth: "100rem" }} emptyMessage="No fitter sign-in data available for the selected date">
                            <Column field="clientAccount" header="Client Account" filter filterPlaceholder="Search by client account" className="table-header" hidden></Column>
                            <Column field="clientName" header="Client" filter filterPlaceholder="Search by client" className="table-header"></Column>
                            <Column field="site" header="Site" filter filterPlaceholder="Search by site" className="table-header" ></Column>
                            <Column field="systemId" header="SystemId" filter filterPlaceholder="Search by systemid" className="table-header" hidden ></Column>
                            <Column field="fitterId" header="FitterId" filter filterPlaceholder="Search by fitterid" className="table-header" hidden ></Column>
                            <Column field="fitterName" header="Fitter" filter filterPlaceholder="Search by fitter" className="table-header"></Column>
                            <Column field="depotCode" header="DepotCode" filter filterPlaceholder="Search by depot" className="table-header" hidden></Column>
                            <Column field="depotName" header="Depot" filter filterPlaceholder="Search by depot" className="table-header"></Column>
                            <Column field="measureId" key="measureId" header="MeasureId" filter filterPlaceholder="Search by measureid" className="table-header" hidden></Column>
                            <Column field="worksheetNo" header="WorksheetNo" filter filterPlaceholder="Search by worksheetno" className="table-header" hidden></Column>
                            <Column field="measureType" header="Measure Type" filter filterPlaceholder="Search by measure type" className="table-header"></Column>
                            <Column field="plannedDate" header="PlannedDate" filter filterPlaceholder="Search by planned date" className="table-header"></Column>
                            <Column field="submissionType" header="Submission Type" filter filterPlaceholder="Search by submission type" className="table-header"></Column>
                            <Column field="submissionStatus" header="Submission Status" filter filterPlaceholder="Search by submission status" className="table-header" hidden></Column>
                            <Column field="signIn" header="SignIn" filter filterPlaceholder="Search by signIn" className="table-header"></Column>
                            <Column field="signOut" header="SignOut" filter filterPlaceholder="Search by signOut" className="table-header"></Column>
                            <Column field="hoursWorked" header="Hours Worked" filter filterPlaceholder="Search by hours worked" className="table-header"></Column>
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default FitterSignInReport;